import { HttpEventType, HttpResponse } from "@angular/common/http";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  FormControl,
} from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { type } from "os";
import { Subscription, Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import {
  Application,
  Fabric,
  FileTypes,
  LicenseCheckFlag,
  Mpi,
} from "src/app/core/models/application";
import { UploadFileTypes } from "src/app/core/models/globals";
import { ApplicationService } from "src/app/core/services/application.service";
import { AuthenticationService } from "src/app/core/services/authentication.service";
import { FileEditorForApplicationComponent } from "../file-editor-for-application/file-editor-for-application.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxSpinnerService } from "ngx-spinner";
import { ConfirmDialogComponent } from "src/app/modules/shared/components/confirm-dialog/confirm-dialog.component";
import { MatSelectChange } from "@angular/material/select";

@Component({
  selector: "app-upload-file-application",
  templateUrl: "./upload-file-application.component.html",
  styleUrls: ["./upload-file-application.component.scss"],
})
export class UploadFileApplicationComponent implements OnInit {
  submitActive: boolean = false;
  uploadAppForm: UntypedFormGroup;
  application: Application = this.data.application;
  toShow: boolean = false;
  uploadFlag: boolean = false;
  scriptFileUploadPer: string;
  cancelledFiles = {};
  scriptUploadSub: Subscription;
  executeFiles = [];
  licenseFiles = [];
  graphFiles = [];
  cancelFiles = [];
  resumeFiles = [];
  suspendFiles = [];
  // iconFiles = [];
  customActionFiles = [];

  types: FileTypes[] = [
    { name: 'Execute File', value: '0' },
    { name: 'License File', value: '1' },
    { name: 'Cancel File', value: '2' },
    { name: 'Resume File', value: '3' },
    { name: 'Suspend File', value: '4' },
    { name: 'Graph File', value: '5' },
    // { name: 'Icon File', value: '6' },
    { name: 'Custom Action File', value: '7'}
  ];
  mpi: Mpi[] = [
    { name: "Intel MPI", value: "0" },
    { name: "MPICH", value: "1" },
    { name: "OpenMPI", value: "2" },
    { name: "Platform MPI", value: "3" },
  ];
  licenseCheckFlags: LicenseCheckFlag[] = [
    { name: "Enabled", value: "True" },
    { name: "Disabled", value: "False" },
  ];
  fabrics: Fabric[] = [
    { name: "dapl", value: "0" },
    { name: "tcp", value: "1" },
    { name: "shm", value: "2" },
    { name: "tmi", value: "3" },
    { name: "ofa", value: "4" },
    { name: "ofi", value: "5" },
    { name: "efa", value: "6" },
  ];

  private fileTypeMap: { [key: string]: string } = {
    '0': 'executeFilesApp',
    '1': 'licenseScript',
    '2': 'cancelScript',
    '3': 'resumeScript',
    '4': 'suspendScript',
    '5': 'graphFilesApp',
    // '6': 'iconFile',
    '7': 'customActionFiles',
  };

  private fileArrayMap: { [key: string]: string[] } = {
    '0': this.executeFiles,
    '1': this.licenseFiles,
    '2': this.cancelFiles,
    '3': this.resumeFiles,
    '4': this.suspendFiles,
    '5': this.graphFiles,
    // '6': this.iconFiles,
    '7': this.customActionFiles,
  };

  @ViewChild("chooseAppFile") chooseAppFile;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { application: Application },
    public dialog: MatDialogRef<UploadFileApplicationComponent>,
    private applicationService: ApplicationService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialog,

    private _spinner: NgxSpinnerService
  ) {
    this.uploadAppForm = new UntypedFormGroup({
      fileTypeApp: new UntypedFormControl(this.types[0], Validators.required),
      chooseAppFile: new UntypedFormControl(
        { value: null, disabled: true },
        Validators.required
      ),
      userScriptFile: new UntypedFormControl(
        { value: null, disabled: true },
        Validators.required
      ),
      executeFilesApp: new UntypedFormControl(''),
      graphFilesApp: new UntypedFormControl(''),
      licenseScript: new UntypedFormControl(''),
      resumeScript: new UntypedFormControl(''),
      cancelScript: new UntypedFormControl(''),
      suspendScript: new UntypedFormControl(''),
      // iconFile: new UntypedFormControl(''),
      customActionFiles: new UntypedFormControl(''),
    });
  }

  ngOnInit() {
    this.splitAndPushIfNotExists(
      this.application.licenseFile,
      this.licenseFiles
    );
    this.splitAndPushIfNotExists(
      this.application.executeFile,
      this.executeFiles
    );
    this.splitAndPushIfNotExists(this.application.graphFiles, this.graphFiles);
    this.splitAndPushIfNotExists(this.application.cancelFile, this.cancelFiles);
    this.splitAndPushIfNotExists(this.application.resumeFile, this.resumeFiles);
    this.splitAndPushIfNotExists(
      this.application.suspendFile,
      this.suspendFiles
    );
    this.splitAndPushIfNotExists(this.application.customActionFile, this.customActionFiles);

    const graphFilesDefault = this.application.graphFiles?.split(",")[0] || "";
    this.uploadAppForm.controls["graphFilesApp"].setValue(
      [graphFilesDefault]
    );
    const executeFileDefault = this.application.executeFile?.split(",")[0] || "";
    this.uploadAppForm.controls["executeFilesApp"].setValue(
      [executeFileDefault]
    );
    const licenseFileDefault = this.application.licenseFile?.split(",")[0] || "";
    this.uploadAppForm.controls["licenseScript"].setValue(
      [licenseFileDefault]
    );
    const resumeFileDefault = this.application.resumeFile?.split(",")[0] || "";
    this.uploadAppForm.controls["resumeScript"].setValue(
      [resumeFileDefault]
    );
    const suspendFileDefault = this.application.suspendFile?.split(",")[0] || "";
    this.uploadAppForm.controls["suspendScript"].setValue(
      [suspendFileDefault]
    );
    const cancelFileDefault = this.application.cancelFile?.split(",")[0] || "";
    this.uploadAppForm.controls["cancelScript"].setValue(
      [cancelFileDefault]
    );
    // this.uploadAppForm.controls["iconFile"].setValue(
    //   this.application.iconFile?.split(",") || []
    // );
    this.uploadAppForm.controls['customActionFiles'].setValue(
      this.application.customActionFile?.split(",") || []
    )
  }  

  ngAfterViewInit() {
    setTimeout(() => {
      const elements = document.querySelectorAll('#ScriptFileReadOnly .mat-mdc-form-field-subscript-wrapper');
      elements.forEach((el) => {
        if (!el.textContent.trim()) {
          el.setAttribute('style', 'display: none !important');
        }
      });
    });
  }

  splitAndPushIfNotExists(source, targetArray) {
    if (source && source.includes(",")) {
      targetArray.push(...source.split(","));
    } else if (source != null && !targetArray.includes(source)) {
      targetArray.push(source);
    }
  }

  onFileChange(inputName) {
    switch (inputName) {
      case "chooseAppFile":
        this.chooseAppFile.nativeElement.value = null;
    }
  }

  onClose() {
    let flag: boolean = (this.application.executeFile?.split(",").length ?? 0) > 1 || 
                   (this.application.graphFiles?.split(",").length ?? 0) > 1 ||
                   (this.application.licenseFile?.split(",").length ?? 0) > 1 || 
                   (this.application.resumeFile?.split(",").length ?? 0) > 1 || 
                   (this.application.cancelFile?.split(",").length ?? 0) > 1 ||
                   (this.application.suspendFile?.split(",").length ?? 0) > 1;

    if (this.uploadAppForm.dirty || flag) {
      let updatedApplication: Application = {
        appName: this.application.appName,
        appVersion: this.application.appVersionText,
        modules: this.application.modules,
        mpi: this.mpi.find((m) => m.name == this.application.mpi)?.value,
        fabric: this.fabrics.find((f) => f.name == this.application.fabric)
          ?.value,
        licenseCheckFlag: this.application.licenseCheckFlag,
        graphFiles: this.SelectedFileToFront(this.application.graphFiles, 'graphFilesApp'),
        executeFile: this.SelectedFileToFront(this.application.executeFile, 'executeFilesApp'),
        licenseFile: this.SelectedFileToFront(this.application.licenseFile, 'licenseScript'),
        resumeFile: this.SelectedFileToFront(this.application.resumeFile, 'resumeScript'),
        cancelFile: this.SelectedFileToFront(this.application.cancelFile, 'cancelScript'),
        suspendFile: this.SelectedFileToFront(this.application.suspendFile, 'suspendScript'),
        customActionFile: this.application.customActionFile,
        staticCores: this.application.staticCores,
        applicationNodeGroups: this.application.applicationNodeGroups,
        memoryPerCPU: this.application.memoryPerCPU,
      };
      this.dialog.close({
        updatedApp: updatedApplication,
        currApp: this.application,
      });
    }
    else{
      this.dialog.close(false);
    }
  }

  private SelectedFileToFront(currentFiles: string | null | undefined, File: string): string {
    let selectedFile = this.uploadAppForm.get(File)?.value
    if (!selectedFile && selectedFile[0] == null || selectedFile[0] == '') {
      return currentFiles;
    }
    
    if (!currentFiles) {
      return selectedFile[0];
    }
    
    // Split current files, remove the selected file if it exists, then add it to the front so that the selected file will only persist in wwwroot and database.
    const filesArray = currentFiles.split(',').map(f => f.trim()).filter(f => f !== selectedFile[0]);
    return [selectedFile, ...filesArray].join(',');
  }

  onSubmit() {
    if (this.uploadAppForm.status == "INVALID") {
      this.snackBar.open("Please fill all the required fields", "Ok", {
        duration: 3000,
      });
      this.uploadAppForm.markAllAsTouched();
    } else {
      let updatedApplication: Application = {
        appName: this.application.appName,
        appVersion: this.application.appVersionText,
        modules: this.uploadAppForm.value.modulesApp,
        mpi: this.mpi.find((m) => m.name == this.application.mpi)?.value,
        fabric: this.fabrics.find((f) => f.name == this.application.fabric)
          ?.value,
        licenseCheckFlag: this.application.licenseCheckFlag,
        graphFiles: this.uploadAppForm.value.graphFilesApp?.join(",") || null,
        executeFile:
          this.uploadAppForm.value.executeFilesApp?.join(",") || null,
        licenseFile: this.uploadAppForm.value.licenseScript?.join(",") || null,
        resumeFile: this.uploadAppForm.value.resumeScript?.join(",") || null,
        cancelFile: this.uploadAppForm.value.cancelScript?.join(",") || null,
        suspendFile: this.uploadAppForm.value.suspendScript?.join(",") || null,
        // iconFile: this.uploadAppForm.value.iconFile?.join(",") || null,
        customActionFile: this.uploadAppForm.value.customActionFiles?.join(",") || null,
        staticCores: this.application.staticCores,
        applicationNodeGroups: this.application.applicationNodeGroups,
        memoryPerCPU: this.application.memoryPerCPU,
      };
      this.dialog.close({
        updatedApp: updatedApplication,
        currApp: this.application,
      });
    }
  }
  uploadFiles(file, id?: string) {
    if (file) {
      if (file?.name?.includes(' ')) {
        this.snackBar.open("File name cannot contain spaces", "OK", {
          duration: 5000,
        });
        return;
      }

      let myFile: File = file;
      this.toShow = true;
      this.scriptFileUploadPer = "0";
      this.cancelledFiles[id] = new Subject();

      let fileType = this.uploadAppForm.value?.fileTypeApp?.name;
      if (fileType == "Execute File") {
        if (this.uploadAppForm.value.executeFilesApp) {
          let exefile: string[] = this.uploadAppForm.value.executeFilesApp;
          if (exefile.length && exefile.some(file => file.trim() !== '')) {
            this.dialogRef
              .open(ConfirmDialogComponent, {
                autoFocus: false,
                disableClose: false,
                width: "25%",
                data: {
                  titleMessage: "Replace Confirmation",
                  bodyMessage: `Do you want to Replace current execute file with ${file.name}?`,
                  cancelText: "Cancel",
                  submitText: "Replace",
                },
              })
              .afterClosed()
              .subscribe((res) => {
                if (res) {
                  // Store current selection before attempting upload
                  const currentSelection = [...exefile];
                  this.uploadFileStartWithFallback(id, myFile, fileType, 'executeFilesApp', currentSelection);
                }
              });
          } else {
            this.uploadFileStart(id, myFile, fileType);
          }
        }
      }

      if (fileType == "License File") {
        if (this.uploadAppForm.value.licenseScript) {
          let licfile: string[] = this.uploadAppForm.value.licenseScript;
          if (licfile.length && licfile.some(file => file.trim() !== '')) {
            this.dialogRef
              .open(ConfirmDialogComponent, {
                autoFocus: false,
                disableClose: false,
                width: "25%",
                data: {
                  titleMessage: "Replace Confirmation",
                  bodyMessage: `Do you want to Replace current License file with ${file.name}?`,
                  cancelText: "Cancel",
                  submitText: "Replace",
                },
              })
              .afterClosed()
              .subscribe((res) => {
                if (res) {
                  const currentSelection = [...licfile];
                  this.uploadFileStartWithFallback(id, myFile, fileType, 'licenseScript', currentSelection);
                }
              });
          } else {
            this.uploadFileStart(id, myFile, fileType);
          }
        }
      }

      if (fileType == "Resume File") {
        if (this.uploadAppForm.value.resumeScript) {
          let resumefile: string[] = this.uploadAppForm.value.resumeScript;
          if (resumefile.length && resumefile.some(file => file.trim() !== '')) {
            this.dialogRef
              .open(ConfirmDialogComponent, {
                autoFocus: false,
                disableClose: false,
                width: "25%",
                data: {
                  titleMessage: "Replace Confirmation",
                  bodyMessage: `Do you want to Replace current Resume file with ${file.name}?`,
                  cancelText: "Cancel",
                  submitText: "Replace",
                },
              })
              .afterClosed()
              .subscribe((res) => {
                if (res) {
                  const currentSelection = [...resumefile];
                  this.uploadFileStartWithFallback(id, myFile, fileType, 'resumeScript', currentSelection);
                }
              });
          } else {
            this.uploadFileStart(id, myFile, fileType);
          }
        }
      }

      if (fileType == "Cancel File") {
        if (this.uploadAppForm.value.cancelScript) {
          let cancelfile: string[] = this.uploadAppForm.value.cancelScript;
          if (cancelfile.length && cancelfile.some(file => file.trim() !== '')) {
            this.dialogRef
              .open(ConfirmDialogComponent, {
                autoFocus: false,
                disableClose: false,
                width: "25%",
                data: {
                  titleMessage: "Replace Confirmation",
                  bodyMessage: `Do you want to Replace current Cancel file with ${file.name}?`,
                  cancelText: "Cancel",
                  submitText: "Replace",
                },
              })
              .afterClosed()
              .subscribe((res) => {
                if (res) {
                  const currentSelection = [...cancelfile];
                  this.uploadFileStartWithFallback(id, myFile, fileType, 'cancelScript', currentSelection);
                }
              });
          } else {
            this.uploadFileStart(id, myFile, fileType);
          }
        }
      }

      if (fileType == "Suspend File") {
        if (this.uploadAppForm.value.suspendScript) {
          let suspendfile: string[] = this.uploadAppForm.value.suspendScript;
          if (suspendfile.length && suspendfile.some(file => file.trim() !== '')) {
            this.dialogRef
              .open(ConfirmDialogComponent, {
                autoFocus: false,
                disableClose: false,
                width: "25%",
                data: {
                  titleMessage: "Replace Confirmation",
                  bodyMessage: `Do you want to Replace current Suspend file with ${file.name}?`,
                  cancelText: "Cancel",
                  submitText: "Replace",
                },
              })
              .afterClosed()
              .subscribe((res) => {
                if (res) {
                  const currentSelection = [...suspendfile];
                  this.uploadFileStartWithFallback(id, myFile, fileType, 'suspendScript', currentSelection);
                }
              });
          } else {
            this.uploadFileStart(id, myFile, fileType);
          }
        }
      }

      if (fileType == "Graph File") {
        if (this.uploadAppForm.value.graphFilesApp) {
          let graphfile: string[] = this.uploadAppForm.value.graphFilesApp;
          if (graphfile.length && graphfile.some(file => file.trim() !== '')) {
            this.dialogRef
              .open(ConfirmDialogComponent, {
                autoFocus: false,
                disableClose: false,
                width: "25%",
                data: {
                  titleMessage: "Replace Confirmation",
                  bodyMessage: `Do you want to Replace current Graph file with ${file.name}?`,
                  cancelText: "Cancel",
                  submitText: "Replace",
                },
              })
              .afterClosed()
              .subscribe((res) => {
                if (res) {
                  const currentSelection = [...graphfile];
                  this.uploadFileStartWithFallback(id, myFile, fileType, 'graphFilesApp', currentSelection);
                }
              });
          } else {
            this.uploadFileStart(id, myFile, fileType);
          }
        }
      }

      if (fileType == 'Custom Action File') {
        this.uploadFileStart(id, myFile, fileType);
      }


      // if (fileType == "Graph File") {
      //   if (this.uploadAppForm.value.suspendScript) {
      //     let suspendfile: string[] = this.uploadAppForm.value.resumeScript;
      //     if (suspendfile.length != 0) {
      //       this.dialogRef
      //         .open(ConfirmDialogComponent, {
      //           autoFocus: false,
      //           disableClose: false,
      //           width: "25%",
      //           data: {
      //             titleMessage: "Replace Confirmation",
      //             bodyMessage: `Do you want to Replace current Suspend file with ${file.name}?`,
      //             cancelText: "Cancel",
      //             submitText: "Delete",
      //           },
      //         })
      //         .afterClosed()
      //         .subscribe((res) => {
      //           if (res) {
      //             this.uploadAppForm.controls["suspendScript"].setValue([]);
      //             this.uploadFileStart(id, myFile, fileType);
      //           }
      //         });
      //     } else {
      //       this.uploadFileStart(id, myFile, fileType);
      //     }
      //   }
      // }
    }
  }
  // New method that handles upload with fallback to original selection on failure
  uploadFileStartWithFallback(id, myFile, fileType, controlName: string, originalSelection: string[]) {
    // Clear the selection only after starting the upload process
    this.uploadAppForm.controls[controlName].setValue([]);

    this.scriptUploadSub = this.applicationService
      .UploadApplicationFile(
        this.application.depName,
        this.application.appName,
        this.application.appVersionText,
        fileType,
        myFile
      )
      .pipe(
        filter((file) => !!file),
        takeUntil(this.cancelledFiles[id])
      )
      .subscribe({
        next: (event: any) => {
          this.uploadFlag = true;
          if (event.type === HttpEventType.UploadProgress) {
            this.scriptFileUploadPer = Math.round(
              (100 * event.loaded) / event.total
            ).toString();
          } else if (event instanceof HttpResponse) {
            this.uploadFlag = false;
            // On successful upload, set the new file
            this.uploadAppForm.controls[id].setValue([myFile.name]);
            this.updateAvailableScripts(myFile.name, id);
          }
          this.submitActive = false;
        },
        error: (err: any) => {
          this.scriptFileUploadPer = "Failed";
          this.submitActive = false;
          this.snackBar.open("File with same name already Exists", "Ok", {
            duration: 3000,
          });
          this.uploadFlag = false;
          // On upload failure, restore the original selection
          this.uploadAppForm.controls[controlName].setValue(originalSelection);
        },
      });
  }
  uploadFileStart(id, myFile, fileType) {
    this.scriptUploadSub = this.applicationService
      .UploadApplicationFile(
        this.application.depName,
        this.application.appName,
        this.application.appVersionText,
        fileType,
        myFile
      )
      .pipe(
        filter((file) => !!file),
        takeUntil(this.cancelledFiles[id])
      )
      .subscribe({
        next: (event: any) => {
          this.uploadFlag = true;
          if (event.type === HttpEventType.UploadProgress) {
            this.scriptFileUploadPer = Math.round(
              (100 * event.loaded) / event.total
            ).toString();
          } else if (event instanceof HttpResponse) {
            this.uploadFlag = false;
            // this.autoFillDetails()
            this.uploadAppForm.controls[id].setValue([myFile.name]);
            this.updateAvailableScripts(myFile.name, id);
          }
          this.submitActive = false;
        },
        error: (err: any) => {
          this.scriptFileUploadPer = "Failed";
          this.submitActive = false;
          this.snackBar.open("File with same name already Exists", "Ok", {
            duration: 3000,
          });
          this.uploadFlag = false;
        },
      });
      //this.uploadAppForm.controls[id].setValue([myFile.name]);
  }

  removeFile(id) {
    this.uploadAppForm.controls[id].setValue("");
    this.toShow = false;
  }

  updateAvailableScripts(fileName: string, id: string) {
    const selectedFileType = this.uploadAppForm.get("fileTypeApp").value;
    const controlName = this.fileTypeMap[selectedFileType.value];

    if (controlName) {
      this.updateFormControl(controlName, fileName);
      this.fileArrayMap[selectedFileType.value].push(fileName);
    }

    this.uploadAppForm.get(id).setValue(fileName);
    this.uploadAppForm.markAsDirty();
  }

  private updateFormControl(controlName: string, fileName: string) {
    const control = this.uploadAppForm.get(controlName);
    const currentValue = control.value;
    const newValue = currentValue ? [...currentValue, fileName] : [fileName];
    control.setValue(newValue.filter(x => x && x != '' && ' '));
    control.markAsDirty();
  }

  createNewFile() {
    let selectedFileType = this.uploadAppForm.value.fileTypeApp.value;
    switch (selectedFileType) {
      case this.types[0].value:
        this.openFileEditor(UploadFileTypes.ExecuteFile, null);
        break;
      case this.types[1].value:
        this.openFileEditor(UploadFileTypes.LicenseFile, null);
        break;
      case this.types[2].value:
        this.openFileEditor(UploadFileTypes.CancelFile, null);
        break;
      case this.types[3].value:
        this.openFileEditor(UploadFileTypes.ResumeFile, null);
        break;
      case this.types[4].value:
        this.openFileEditor(UploadFileTypes.SuspendFile, null);
        break;
      case this.types[6].value:
        this.openFileEditor(UploadFileTypes.CustomActionFile, null);
        break;
      default:
        break;
    }
  }

  openFileEditor(type, fileName) {
    this.getFileContent(type, fileName);
  }

  getFileContent(type, fileName) {
    let id = "userScriptFile";
    this._spinner.show("fileEditor");
    const dialogRef = this.dialogRef
      .open(FileEditorForApplicationComponent, {
        disableClose: true,
        autoFocus: false,
        width: "70%",
        height: "80%",
        id: "editorDialog",
        panelClass: "file-editor-dialog",
        data: {
          depName: this.application.depName,
          appName: this.application.appName,
          appVersion: this.application.appVersionText,
          type: type,
          fileName: fileName,
        },
        hasBackdrop: false,
      })
      .afterClosed()
      .subscribe({
        next: (data) => {
          if (data) {
            this.uploadFiles(data, id);
          }
        },
      });
  }


  // This function will ensure that only one file is selected or zero file is selected to delete it properly
  selectOnlyOneFile(currentlySelectedOption: string, uploadFile: string){
    const upload = this.uploadAppForm.get(uploadFile);

    if(upload?.value?.includes(currentlySelectedOption))
      upload.setValue([currentlySelectedOption]);
    else{
      upload.setValue([]);
    }
  }
}
